import { Typography, Divider } from '@mui/material';
import { Stack } from '@mui/system';
import { ShopItem } from 'src/types/events/shop';

import Iconify from '../../components/iconify';
import { TicketSetting } from '../../types';
import { ExpandableDescription } from './expandable-description';

interface Props {
  ticket: TicketSetting | ShopItem;
}

export default function TicketInfoHeader({ ticket }: Props) {
  const isTicketSetting = (ticketItem: TicketSetting | ShopItem): ticketItem is TicketSetting =>
    'bundleSize' in ticket;

  return (
    <>
      <Stack direction="row">
        <Typography variant="subtitle1" flexGrow={1}>
          {ticket?.title}
        </Typography>
        {isTicketSetting(ticket) && ticket?.bundleSize > 1 && (
          <Stack direction="row" gap={0.5} alignItems="center">
            <Iconify icon="solar:ticket-broken" />
            <Typography> x {ticket?.bundleSize}</Typography>
          </Stack>
        )}
      </Stack>
      {ticket?.description && <Divider sx={{ mt: 1, mb: ticket?.description ? 1 : 2 }} />}
      {ticket?.description && <ExpandableDescription text={ticket.description} />}
    </>
  );
}
